import {createSelector} from 'reselect';
import {getPickTimestamp} from 'components/Cards/Pick/helpers';

const followingPicksState = state => state.followingPicks;

export const getFollowingPicks = createSelector(followingPicksState, followingPicks => followingPicks);

export const getFollowingPicksCount = createSelector(getFollowingPicks, ({length}) => length);

export const getSortedFollowingPicks = createSelector(getFollowingPicks, followingPicks =>
  followingPicks.sort((a, b) => getPickTimestamp(a.event) - getPickTimestamp(b.event)),
);
